import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Grid,
  Avatar,
  Paper,
  Stack,
} from "@mui/material";

function DriverEarnings({ earnings }) {
  return (
    <Card>
      <Stack direction="row" spacing={2} alignItems="center">
        <Paper
          elevation={3}
          style={{
            backgroundColor: "white",
            width: 50,
            height: 50,
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "3px",
          }}
        >
          <Avatar style={{ backgroundColor: "white" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#5f6368"
            >
              <path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" />
            </svg>
          </Avatar>
        </Paper>
        <CardHeader
          title={
            <Typography variant="h6" color="#667085">
              Earnings
            </Typography>
          }
        />
      </Stack>
      <Divider />
      <CardContent>
        <Grid container spacing={2} marginTop={2}>
          {earnings.map((earning, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Typography variant="body1" component="div" color="#667085">
                {earning.period}
              </Typography>
              <Typography variant="h6" component="div">
                ₹ {earning.earnings}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default DriverEarnings;
